import { Row, Input, Button, Form, Modal, message } from 'antd';
import { useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import logoLogin from "../../../../../assets/images/kyc/logo-login.png";
import iconNext from "../../../../../assets/images/icon/next-arrow.svg";
import environment from "../../../../../config/environment";
import { i18n } from '../../../../../i18n/i18n';
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../../i18n/i18n.constants";
import alert from "../../../../../assets/images/kyc/alert.png";
import "./index.css";

const LoginKycPage = () => {
  const [dataCardId, setDataCardId] = useState<string>('');
  const [dataCardMobile, setDataMobile] = useState<string>('');
  const history = useHistory();
  const { t } = useTranslation(namespaces.pages.daolSecKyc);
  const [isLoading, setLoading] = useState(false);

  const onChangeCardId = (e) => {
    setDataCardId(e.target.value);
    // console.log(`setDataCardId = ${dataCardId}`);
  };

  const onSubmitLogin = (e: React.FormEvent<HTMLFormElement>) => {
    const url = `${environment?.baseApi}/verifyKyc`

    var mockData = {
      cardId: dataCardId,
      mobile: dataCardMobile
    }

    setLoading(true);
    // console.log(`BaseAPI  = ${url}`);
    // console.log(`mockData  = ${mockData.cardId}`);
    axios.post(url, mockData)
      .then(res => {
        if (res.status === 200) {
          if (res.data === 'Please update mobile phone') {
            Modal.error({
              icon: <img src={alert} className="img-popup" alt="alert" />,
              title: t("popup_login_error_title_mobile"),
              content: t("popup_login_error_content_mobile"),
              okText: t("btn_ok"),
              onOk() { },
            });
            setLoading(false);
          }
          if (res.data === 'No Data') {
            Modal.error({
              icon: <img src={alert} className="img-popup" alt="alert" />,
              title: t("popup_login_error_title"),
              content: (<><div>{t("popup_login_error_content")}</div></>),
              okText: t("btn_again"),
              onOk() { },
            });
            setLoading(false);
          }
          if (res.data.toString() === dataCardId) {
            axios.get(`${environment?.baseApi}/getKycCustomer?cardId=${dataCardId}`)
              .then(resCustomer => {
                // console.log('resCustomer', resCustomer)
                if (res.status === 200) {
                  history.push({
                    pathname: "/contents/daolSec/kyc/otp",
                    state: {
                      cardId: resCustomer.data.cardId,
                      id: resCustomer.data.id,
                      mobile: resCustomer.data.mobile,
                    },
                  });
                }
              })
          }
        }else {
          Modal.error({
            icon: <img src={alert} className="img-popup" alt="alert" />,
            title: t("popup_error_title"),
            content: (<><div>{t("popup_error_content")}</div></>),
            okText: t("btn_again"),
            onOk() { },
          });
        }
      }).catch((error) => {
        console.error(error);
      });
  };

  return (
    <>

      <div className="home-page mainkyc-page">
        {isLoading === true ?
          <div className="sping-loading">
            <div className="loading"></div>
            <p>{t("loading")}</p>
          </div> : ""}

        <div className="container">
          {/* {console.log('i18n.language', i18n.language)} */}
          <Row className="container-main daol-kyc">
            <div className="content-right col-sm-8 text-center">
              <p><img src={logoLogin} alt="Login" /></p>
              <p className="text-center">{t("login_text_descrip")}</p>

              <Form name="normal_login" className="loginKyc-form" initialValues={{ remember: true }} onFinish={onSubmitLogin}>
                <div className="container-from">
                  <Form.Item name="cardId" label={t("login_label_cardId")} className="from-input">
                    <Input placeholder={t("login_cardId_placeholder")} onChange={onChangeCardId} className="input-info" />
                  </Form.Item>
                </div>
                <Form.Item className="container-button btn-kyc">
                  <Button type="primary" disabled={dataCardId === '' ? true : false} htmlType="submit" className="btn-next">
                    {t("btn_next")}
                    <img src={iconNext} alt="icon-next" />
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Row>
        </div>
      </div>

    </>
  );
};
export default LoginKycPage;
